/**Dependencies */
import React, { useEffect, useState } from "react";
import { logosCadenasHoteleras, infoPayMethods } from "../helpers";
import { calculateBookingDates } from "../helpers";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { PrincipalBanner } from "../components/PrincipalBanner";
import { CarouselHotels } from "../components/CarouselHotels";
import { InformationSection } from "../components/InformationSection";
import { Button } from "react-bootstrap";

/**Styles */
import "../styles/index.scss";

/**Images */
import bannerContacto from "../images/banners/Banner de contacto.png";
import bannerAuroras from "../images/banners/Banner auroras boreales.png";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

// Services
import { elementoPorSeccion } from "../services/adminProductService";

export const Destinos = ({ idElemento = 2 }) => {
  const [imgsBanners, setImgsBanners] = useState([]);
  const { checkIn, checkOut } = calculateBookingDates();

  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[1].imagenes.map((img) => ({
          image: img.url,
          texto: img.texto,
        }));

        setImgsBanners(formattedImages);
      } catch (err) {
        console.error("Error al cargar las imágenes:", err);
      }
    };

    fetchElemento();
  }, [idElemento]);

  return (
    <div className="destinos">
      <PrincipalBanner idElemento={2} showSearch={false} />
      <div className="py-5">
        <div className="text-center mb-5">
          <h1 className="section-title outline">Nuestros destinos TOP</h1>
          <p className="section-subtitle">
            Descubre por qué International Travel Net tiene los mejores destinos
            al precio exacto para un viaje extraordinario.
          </p>
        </div>
        <div className="carousel-container">
          <Swiper
            navigation={true}
            spaceBetween={15}
            slidesPerView={1}
            loop={true}
            modules={[Navigation]}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3.7,
              },
            }}
          >
            {imgsBanners.map((image, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={`/alojamientos?t=destino&id=${image.texto}&in=${checkIn}&out=${checkOut}&hab=1&pax1=2|0|0`}
                >
                  <img
                    src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image.image}`}
                    alt={`Imagen ${index + 1}`}
                    style={{ width: "100%", height: "600px" }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div className="py-5 container">
        <div className="text-center mb-5">
          <h1 className="section-title">Conoce toda la gama de Hoteles</h1>
        </div>
        <div className="slider-container carousel-container">
          <div className="custom-prev" id="prev-logos">
            <IoIosArrowBack />
          </div>
          <Swiper
            navigation={{
              nextEl: "#next-logos",
              prevEl: "#prev-logos",
            }}
            spaceBetween={15}
            slidesPerView={2}
            loop={true}
            autoplay={{ delay: 3000 }}
            modules={[Navigation]}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 8,
              },
            }}
          >
            {logosCadenasHoteleras.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt={`Imagen ${index + 1}`}
                  style={{ width: "100%", height: "150px" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-next" id="next-logos">
            <IoIosArrowForward />
          </div>
        </div>
      </div>

      <div className="py-5">
        <div style={{ position: "relative", width: "100%", height: "360px" }}>
          <img
            src={bannerContacto}
            alt="Imagen"
            style={{ width: "100%", height: "100%" }}
          />
          <a
            href="tel:+7772035097"
            style={{ fontSize: "17px", color: "white" }}
          >
            <Button className="btn-travel-us"> 777 203 5097</Button>
          </a>
        </div>
      </div>

      <div>
        <CarouselHotels
          idElemento={2}
          arrPosition={2}
          title={"Hoteles Recomendados"}
        />
      </div>

      <div className="py-5" style={{ width: "100%" }}>
        <img
          src={bannerAuroras}
          alt="Banner auroras boreales"
          style={{ width: "100%" }}
        />
      </div>

      <div>
        <InformationSection arrInfo={infoPayMethods} />
      </div>
    </div>
  );
};
